export default "__VITE_ASSET__QNe$dV5l__"